export enum OIV_TYPE {
    PARA = 'PARA',
    CONTAINER = 'CONTAINER',
    CHAPTER = 'CHAPTER',
    CHAPTER_TITLE = 'CHAPTER_TITLE',
    BULLET_LIST = 'BULLET_LIST',
    NUMBERED_LIST = 'NUMBERED_LIST',
    LIST_ITEM = 'LIST_ITEM',
    LIST_ITEM_TITLE = 'LIST_ITEM_TITLE',
    BOX = 'BOX',
    BOX_TITLE = 'BOX_TITLE',
    INFO = 'INFO',
    TOPIC = 'TOPIC',
    TOPIC_TITLE = 'TOPIC_TITLE',
    SECTION_TITLE = 'SECTION_TITLE',
    CONTAINER_LIST = 'CONTAINER_LIST',
    INTRO = 'INTRO',
    NUM_GROUP = 'NUM_GROUP',
    TABLE = 'TABLE',
    TABLE_ROW = 'TABLE_ROW',
    TABLE_CELL = 'TABLE_CELL',
    TABLE_COL_SPEC = 'TABLE_COL_SPEC',
}

export const MappingOivType = {
    paragraph: OIV_TYPE.PARA,
    subtitle: OIV_TYPE.SECTION_TITLE,
    bullet: OIV_TYPE.BULLET_LIST, // treat as SECTION only for ki
    numbered: OIV_TYPE.NUMBERED_LIST, //  treat as SECTION for ki
    item: OIV_TYPE.LIST_ITEM, // CONTAINER for ki
    box: OIV_TYPE.BOX,
    info: OIV_TYPE.INFO,
    table: OIV_TYPE.TABLE,
    row: OIV_TYPE.TABLE_ROW,
    cell: OIV_TYPE.TABLE_CELL,
    colspec: OIV_TYPE.TABLE_COL_SPEC,
    head: OIV_TYPE.TOPIC_TITLE,
    title: OIV_TYPE.CHAPTER_TITLE,
    chapter_group: OIV_TYPE.CONTAINER,
    intro: OIV_TYPE.INTRO,
    'num-group': OIV_TYPE.NUM_GROUP,
};

export const SECTION_TYPE = {
    title: OIV_TYPE.CHAPTER,
    head: OIV_TYPE.TOPIC,
};

export enum XML_TAG {
    SUBTITLE = 'subtitle',
    TITLE = 'title',
    BULLET = 'bullet',
    NUMBERED = 'numbered',
    ITEM = 'item',
    SECTION = 'section',
    CHAPTER = 'chapter',
    HEAD = 'head',
    PARA = 'paragraph',
    INTRO = 'intro',
}

export enum CHAPTER_NAME {
    KI = 'ki',
    AB = 'ab',
    FT = 'ft',
    GLOSSARY = 'glossar',
}
